import { Expose, Transform } from "class-transformer";

export class SuperviseTimeOffDto {
  @Transform(({ value }) => value ?? "")
  @Expose()
  supervisionComment: string;
}
